import apiClient from "@/shared/api/apiClient3";

export const getDirectoryItem = async (code, params) => {
  try {
    const { data } = await apiClient.get(`/directory/${code}`, {
      params,
    });
    return data;
  } catch (e) {
    console.error(`Ошибка загрузки элемента ${code}:`, e);
    throw e;
  }
};

export const getDirectoryByParentAllChildren = async (parent_code, params) => {
  try {
    const { data } = await apiClient.get(`/directory/${parent_code}/children`, {
      params,
      metaData: { isNotificationDisabled: true },
    });
    return data;
  } catch (e) {
    console.error(`Ошибка загрузки все потомки элемента ${parent_code}:`, e);
    throw e;
  }
};
